//* Import Components
import { ButtonComponent } from './button/button.component';
import { CardComponent } from './card/card.component';
import { ModalComponent } from './modal/modal.component';
import { PageContentContainerComponent } from './page-content-container/page-content-container.component';
import { PageTitleComponent } from './page-content-container/page-title/page-title.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TabComponent } from './tabs/tab/tab.component';
import { TabsComponent } from './tabs/tabs.component';
import { WatermarkComponent } from './watermark/watermark.component';
import { WidgetComponent } from './widget/widget.component';
import { WidgetsGridComponent } from './widgets-grid/widgets-grid.component';
import { SessionTimeoutComponent } from './session-timeout/session-timeout.component';
import { DetailsTableComponent } from './tables/details/details-table.component';
import { SummaryTableComponent } from './tables/summary/summary-table.component';
import { LogoComponent } from './logo/logo.component';
import { TextInputComponent } from './text-input/text-input.component';
import { DateInputComponent } from './date-input/date-input.component';
import { RadioInputComponent } from './radio-input/radio-input.component';
import { DropdownInputComponent } from './dropdown-input/dropdown-input.component';
import { TooltipComponent } from './tooltip/tooltip.component';

export const components = [
  ButtonComponent,
  CardComponent,
  DetailsTableComponent,
  ModalComponent,
  PageContentContainerComponent,
  PageTitleComponent,
  SessionTimeoutComponent,
  SpinnerComponent,
  SummaryTableComponent,
  TabComponent,
  TabsComponent,
  TabComponent,
  WatermarkComponent,
  WidgetComponent,
  WidgetsGridComponent,
  PageTitleComponent,
  LogoComponent,
  TextInputComponent,
  DateInputComponent,
  RadioInputComponent,
  DropdownInputComponent,
  TooltipComponent,
];

//* Export Components
export * from './button/button.component';
export * from './card/card.component';
export * from './modal/modal.component';
export * from './page-content-container/page-content-container.component';
//export * from './page-content-container/page-title/page-title.component';
//export * from './session-timeout/session-timeout.component';
export * from './spinner/spinner.component';
export * from './tabs/tab/tab.component';
export * from './tabs/tabs.component';
export * from './watermark/watermark.component';
export * from './widget/widget.component';
export * from './widgets-grid/widgets-grid.component';
export * from './tables/details/details-table.component';
export * from './tables/summary/summary-table.component';
export * from './page-content-container/page-title/page-title.component';
export * from './session-timeout/session-timeout.component';

//* Duplicated sp-logo from core components
//TODO: Figure out if there's another way to share a component across 2 modules
export * from './logo/logo.component';
